import { Box, Container, Divider, Grid2 as Grid, Paper, Typography } from '@mui/material'
import React from 'react'

import ImageGallery from '../components/common/ImageGallery'
import Video from '../components/common/Video'

/**
 * DevMedia - Development page to showcase ImageGallery and Video components
 */
const DevMedia = () => {
  // Demo image URLs - using high-quality placeholder images
  const demoImages = [
    'https://images.pexels.com/photos/30230100/pexels-photo-30230100/free-photo-of-stunning-alpine-mountain-peak-with-clear-blue-sky.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    'https://images.pexels.com/photos/1365425/pexels-photo-1365425.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    'https://images.pexels.com/photos/1208777/pexels-photo-1208777.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    'https://images.pexels.com/photos/1365426/pexels-photo-1365426.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    'https://images.pexels.com/photos/1365427/pexels-photo-1365427.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    'https://images.pexels.com/photos/1365428/pexels-photo-1365428.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    'https://images.pexels.com/photos/1365429/pexels-photo-1365429.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    'https://images.pexels.com/photos/1365430/pexels-photo-1365430.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  ]

  return (
    <Container maxWidth="lg">
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Media Components Demo
        </Typography>
        <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 4 }}>
          展示 ImageGallery 和 Video 组件的功能
        </Typography>
        <Divider sx={{ mb: 4 }} />

        {/* Video Component Section */}
        <Box sx={{ mb: 6 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 3 }}>
            Video Component
          </Typography>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 8 }}>
              <Video
                // src="https://img.bookingonsnow.com/output3.mp4"
                src="https://img.bookingonsnow.com/_users_a4e8c117-b16b-47d9-9421-5a521048f3df_generated_584ecc3f-4cf7-42da-98de-3c452f1412bf_generated_video.mov"
                title="示例视频"
                controls={true}
                autoplay={false}
                loop={false}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Paper sx={{ p: 2, height: '100%' }}>
                <Typography variant="h6" gutterBottom>
                  Video 组件特性
                </Typography>
                <Typography variant="body2" component="ul" sx={{ pl: 2 }}>
                  <li>支持标准 HTML5 video 标签</li>
                  <li>可配置控制栏、自动播放、循环等</li>
                  <li>支持自定义海报图片</li>
                  <li>响应式设计，适配不同屏幕尺寸</li>
                  <li>Material-UI 样式集成</li>
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ my: 6 }} />

        {/* ImageGallery Component Section */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 3 }}>
            ImageGallery Component - Coverflow Effect
          </Typography>
          <ImageGallery images={demoImages} title="照片画廊 - Coverflow 效果" collapsible={true} defaultExpanded={true} autoplay={true} autoplayDelay={3000} effect="coverflow" />
        </Box>

        <Divider sx={{ my: 4 }} />

        {/* ImageGallery with Slide Effect */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 3 }}>
            ImageGallery Component - Slide Effect
          </Typography>
          <ImageGallery images={demoImages.slice(0, 5)} title="照片画廊 - 滑动效果" collapsible={true} defaultExpanded={true} autoplay={true} autoplayDelay={4000} effect="slide" />
        </Box>

        <Divider sx={{ my: 4 }} />

        {/* ImageGallery Non-collapsible */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 3 }}>
            ImageGallery Component - Non-collapsible
          </Typography>
          <ImageGallery
            images={demoImages.slice(0, 4)}
            title="照片画廊 - 不可折叠"
            collapsible={false}
            defaultExpanded={true}
            autoplay={true}
            autoplayDelay={3500}
            effect="coverflow"
          />
        </Box>

        <Divider sx={{ my: 4 }} />

        {/* Component Features Summary */}
        <Box>
          <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 3 }}>
            组件功能总结
          </Typography>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Paper sx={{ p: 3, height: '100%' }}>
                <Typography variant="h6" gutterBottom>
                  ImageGallery 组件
                </Typography>
                <Typography variant="body2" component="ul" sx={{ pl: 2 }}>
                  <li>支持多种轮播效果（coverflow, slide, fade, cube, flip）</li>
                  <li>可折叠/展开功能</li>
                  <li>自动播放和手动导航</li>
                  <li>全屏查看模式，支持缩放</li>
                  <li>缩略图导航</li>
                  <li>键盘导航支持</li>
                  <li>响应式设计</li>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Paper sx={{ p: 3, height: '100%' }}>
                <Typography variant="h6" gutterBottom>
                  Video 组件
                </Typography>
                <Typography variant="body2" component="ul" sx={{ pl: 2 }}>
                  <li>标准 HTML5 video 播放器</li>
                  <li>可配置控制栏显示/隐藏</li>
                  <li>支持自动播放、循环播放</li>
                  <li>支持静音模式</li>
                  <li>自定义播放按钮（无控制栏模式）</li>
                  <li>支持海报图片</li>
                  <li>Material-UI 样式集成</li>
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Container>
  )
}

export default DevMedia
